import React, { useEffect, useState } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { fetchMyOrders, Order } from '../../api/orders';
import { formatPrice, hasPrice } from '../../utils/price';

const OrdersPage = () => {
  const { user, loading } = useAuth();
  const [orders, setOrders] = useState<Order[]>([]);
  const [error, setError] = useState('');
  const [fetching, setFetching] = useState(true);

  useEffect(() => {
    if (!user) return;
    fetchMyOrders()
      .then(setOrders)
      .catch(() => setError('Не удалось загрузить заказы'))
      .finally(() => setFetching(false));
  }, [user]);

  if (loading) {
    return <div className="max-w-4xl mx-auto px-4 py-12">Загрузка...</div>;
  }

  if (!user) {
    return <Navigate to="/login?redirect=/orders" replace />;
  }

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">Мои заказы</h1>
      {error && <div className="bg-red-50 text-red-600 p-4 rounded-md mb-4">{error}</div>}
      {fetching ? (
        <p>Загрузка...</p>
      ) : orders.length === 0 ? (
        <div className="bg-white rounded-2xl shadow-md p-8 text-center">
          <p className="text-slate-600 mb-4">У вас пока нет заказов.</p>
          <Link to="/catalog" className="btn-primary">В каталог</Link>
        </div>
      ) : (
        <div className="space-y-4">
          {orders.map((order) => (
            <div key={order.id} className="bg-white rounded-2xl shadow-md p-6">
              <div className="flex flex-wrap justify-between gap-3 mb-4">
                <div>
                  <h2 className="text-xl font-bold">{order.orderNumber}</h2>
                  <p className="text-sm text-slate-500">{new Date(order.createdAt).toLocaleString('ru-RU')}</p>
                </div>
                <div className="text-right">
                  <span className="inline-flex items-center px-3 py-1 rounded-full bg-amber-100 text-amber-900 font-semibold text-sm">
                    {order.statusLabel}
                  </span>
                  <p className="font-extrabold text-primary mt-2">{formatPrice(order.total)}</p>
                </div>
              </div>
              {order.status === 'processing' && (
                <p className="text-sm text-slate-600 mb-3">Мы перезвоним вам в ближайшее время.</p>
              )}
              <div className="space-y-1 text-sm">
                {order.items.map((item, index) => (
                  <div key={index} className="flex justify-between gap-3">
                    <span>{item.name} × {item.quantity}</span>
                    <span>{hasPrice(item.price) ? formatPrice(item.price * item.quantity) : 'Цена по запросу'}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default OrdersPage;
